module.exports = __webpack_public_path__ + "img/invest_card_icon-large.02b18021.svg";